<template lang="pug">
.invitation-other-office-modal
  b-modal(v-model="_value" size="lg" @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    template(#modal-title)
      span 招待メールを送信する他事業所の情報を入力してください。
    
    .register-body.d-flex.flex-column
      FormInput(v-model="mailaddress" key-name="メールアドレス" name="mailaddress" type="text" placeholder="送信先メールアドレス" :maxlength="100" 
        :validation-rules="{ required: true, max: 100, email: true, non_uppercase:true }" required)
      .error-message(v-if="errorMessage" style="margin-top:-6px; margin-bottom:16px; padding-left:20px; font-size:14px;") {{ errorMessage }}
      FormInput(v-model="officeName" key-name="事業所名" name="office-name" type="text" placeholder="事業所名" :maxlength="100" 
        :validation-rules="{ required: true, max: 100 }" required)
      FormInput(v-model="staffName" key-name="担当者名" name="staff-name" type="text" placeholder="担当者名" :maxlength="100" 
        :validation-rules="{ required: true, max: 100 }" required)

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import CustomValidate from "@/commons/utils/CustomValidate";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import { OtherOfficeConnectionTableItem } from "@/pc/containers/base/OtherOfficeConnectionTable.vue";

/**
 * ### OK/キャンセルモーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormInput
  },
  $_veeValidate: { validator: "new" }
})
export default class InvitationOtherOfficeModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** メールアドレスチェックで使用する、登録済みの連携情報 */
  @Prop({ required: true })
  items!: Array<OtherOfficeConnectionTableItem>;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** メールアドレス */
  mailaddress: string = "";
  /** 事業所名 */
  officeName: string = "";
  /** 担当者名 */
  staffName: string = "";

  /** エラーメッセージ */
  errorMessage: string = "";

  get _value(): boolean {
    // モーダル表示タイミングで初期化する
    if (this.value == true) {
      this.mailaddress = "";
      this.officeName = "";
      this.staffName = "";
      this.errorMessage = "";
    }
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.showValidationAlert = false;
    return;
  }

  /**
   * ### vue lifecycle created
   */
  created() {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  public async ok(bvModalEvent: any): Promise<void> {
    bvModalEvent.preventDefault();

    const validationResult: boolean = await this.$validator.validateAll();
    const validationMailaddress: boolean = this.validateMailaddress(this.mailaddress, this.items);
    if (validationResult && validationMailaddress) {
      this.showValidationAlert = false;
      this.$emit("ok", {
        mailaddress: this.mailaddress,
        officeName: this.officeName,
        staffName: this.staffName
      });
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public validateMailaddress(mailaddress: string, items: Array<OtherOfficeConnectionTableItem>): boolean {
    for (const item of items) {
      if (mailaddress === item.mailaddress) {
        this.errorMessage = "既に招待または連携しているメールアドレスのため招待できません";
        return false;
      }
    }
    return true;
  }

  public cancel(): void {
    this.showValidationAlert = false;
    this.$emit("cancel");
    return;
  }
}
</script>
